export default __webpack_public_path__ + "static/media/455.0e6b9d4b.png";